// Copyright (c) 2021 Uber Technologies, Inc.
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { render } from 'react-dom';
import store from './store';
import App from './app';
import Auth from './cognito/AuthComponent';
import Verifyaccount from './cognito/VerifyAccount';
import Forgetpassword from './cognito/ForgetPassword';
import Resetpassword from './cognito/ResetPassword';
import ProtectedRoute from './cognito/ProtectedRoute';
import { AuthProvider } from './cognito/AuthContext';
import Logout from './cognito/Logout';

const Root = () => (
  <AuthProvider>
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/auth" element={<Auth/>} />
          <Route path="/verifyaccount" element={<Verifyaccount />} />
          <Route path="/forgetpassword" element={<Forgetpassword/>} />
          <Route path="/resetpassword" element={<Resetpassword/>} />
          <Route path="/logout" element={<Logout/>} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <App/>
              </ProtectedRoute>
            }
          />
           <Route path="*" element={<Navigate to="/auth" replace />} />
        </Routes>
      </Router>
    </Provider>
  </AuthProvider>
);


render(<Root />, document.body.appendChild(document.createElement('div')));
